import { render, staticRenderFns } from "./refundDetails.vue?vue&type=template&id=588ab2d0&scoped=true"
import script from "./refundDetails.vue?vue&type=script&lang=js"
export * from "./refundDetails.vue?vue&type=script&lang=js"
import style0 from "./refundDetails.vue?vue&type=style&index=0&id=588ab2d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ab2d0",
  null
  
)

export default component.exports